module.exports = __webpack_public_path__ + "img/speedsatellite.1e0c7cc9.png";